import React from 'react';
import { statusConfig } from '../theme';

interface Props {
  status: string;
  className?: string;
}

const StatusBadge: React.FC<Props> = ({ status, className }) => {
  const cfg = statusConfig[status] || { bg: '#F1F3F7', color: '#94A3B8', label: status };
  return (
    <span
      className={`badge ${status.replace(/ /g, '-')} ${className || ''}`}
      style={{ background: cfg.bg, color: cfg.color }}
    >
      <span className="badge-dot" style={{ background: cfg.color }} />
      {cfg.label}
    </span>
  );
};

export default StatusBadge;
